import { createContext, useContext } from 'react';

export type TextAreaType = 'textbox' | 'copilot' | null;

type ContextType = {
  inputText: string;
  clearChatTrigger: boolean;
  focusedTextArea: TextAreaType;
  setFocusedTextArea: (type: TextAreaType) => void;
  insertText: (text: string) => void;
  setInsertTextHandler: (handler: (text: string) => void) => void;
  setInputText: React.Dispatch<React.SetStateAction<string>>;
  setClearChatTrigger: React.Dispatch<React.SetStateAction<boolean>>;
};

export const TextAreaContext = createContext<ContextType | undefined>(
  undefined
);

export const useTextAreaContext = () => {
  const context = useContext(TextAreaContext);
  if (!context)
    throw new Error(
      'useTextAreaContext must be used within a TextAreaProvider'
    );
  return context;
};
